export var alertPushSetting = {
  name: "告警与推送设置",
  path: "/pzSetting",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "23",
  sort: 8,
  alwaysShow: true,
  meta: {
    title: "告警与推送设置",
    icon: "settings-outline",
    noCache: false
  },
  children: [{
    name: "离线告警",
    path: "/offlineAlert",
    hidden: false,
    component: "offlineAlert/index",
    elemCode: "220",
    meta: {
      title: "离线告警",
      noCache: true
    }
  }, {
    name: "告警与推送设置",
    path: "/alertSetting",
    hidden: false,
    component: "alertPushSetting/index",
    elemCode: "230",
    meta: {
      title: "告警与推送设置",
      noCache: true
    }
  }]
};